import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Link, withRouter } from "react-router-dom";
import { slugToCountryPathname } from "../../utils/strings";

const OurServices = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const [selectedService, setSelectedService] = useState({ callToActionUrl: "", callToActionText: "" });
  const [inputIndex, setInputIndex] = useState(0);
  let [value, setValue] = useState("");
  const [loopTimeouts, setLoopTimeouts] = useState({ clearInput: null, nextIndex: null });

  const inputs = [];
  content = JSON.parse(JSON.stringify(content));
  content.ourServices.forEach(service => {
    const callToAction = JSON.parse(service?.callToAction);
    service.tags = service.tags?.map(inputStr => inputStr.text.trim());
    service.callToActionUrl = callToAction?.map(inputStr => inputStr.url.trim());
    service.callToActionText = callToAction?.map(inputStr => {
      if (!inputStr.text.includes("→")) {
        inputStr.text = inputStr.text + " →";
      }
      return inputStr.text.trim();
    });
    service.inputStrings = service.inputStrings?.map(inputStr => {
      inputs.push(inputStr.text.trim());
      return inputStr.text.trim();
    });
  });

  useEffect(() => {
    if (!inputs[inputIndex]) {
      setInputIndex(0);
      return;
    }
    let iv = setInterval(() => {
      if (value?.length < inputs[inputIndex].length) {
        handleChange(inputs[inputIndex].substring(0, value?.length + 1));
        setLinkService(inputs[inputIndex]);
      } else {
        clearInterval(iv);
      }
    }, 30);
    // eslint-disable-next-line
  }, [inputIndex]);

  const setLinkService = vl => {
    let active = content.ourServices.filter(os => {
      return !!os.inputStrings.filter(i => {
        return i.toLowerCase() === vl.trim().toLowerCase();
      })[0];
    })[0] || {
      callToActionUrl: [],
      callToActionText: []
    };
    let linkIdx = -1;
    if (active.callToActionUrl.length) {
      linkIdx = active.inputStrings
        .filter(i => i.toLowerCase() === vl.trim().toLowerCase())
        .map(i => active.inputStrings.indexOf(i))[0];
    }

    setSelectedService({
      callToActionUrl: active.callToActionUrl[linkIdx],
      callToActionText: active.callToActionText[linkIdx]
    });
  };

  const handleChange = vl => {
    value = vl;
    let disables = content.ourServices
      .filter(os => {
        return !os.inputStrings.filter(i => {
          return i.toLowerCase() === vl.trim().toLowerCase();
        })[0];
      })
      .map(os => content.ourServices.indexOf(os));
    if (disables.length === content.ourServices.length) {
      disables = [];
    }
    let active = content.ourServices.filter(os => {
      return !!os.inputStrings.filter(i => {
        return i.toLowerCase() === vl.trim().toLowerCase();
      })[0];
    })[0] || {
      callToActionUrl: [],
      callToActionText: []
    };
    let linkIdx = -1;
    if (active.callToActionUrl.length) {
      linkIdx = active.inputStrings
        .filter(i => i.toLowerCase() === vl.trim().toLowerCase())
        .map(i => active.inputStrings.indexOf(i))[0];
    }

    setSelectedService({
      callToActionUrl: active.callToActionUrl[linkIdx] || selectedService.callToActionUrl,
      callToActionText: active.callToActionText[linkIdx] || selectedService.callToActionText
    });

    setValue(value);

    if (active.callToActionUrl.length) {
      setLoopTimeouts({
        clearInput: setTimeout(() => {
          setValue("");
        }, 2700),
        nextIndex: setTimeout(() => {
          let next =
            inputs
              .filter(i => {
                return i.toLowerCase() === vl.trim().toLowerCase();
              })
              .map(i => inputs.indexOf(i))[0] + 1;

          if (!inputs[next]) {
            next = 0;
          }
          setInputIndex(next);
        }, 3000)
      });
    } else {
      clearTimeout(loopTimeouts.clearInput);
      clearTimeout(loopTimeouts.nextIndex);
    }
  };

  return (
    <div id="ourServicesV4">
      <div className="title">
        <span>{content.title}</span>
      </div>
      <div className="subtitle">
        <span>{content.subtitle}</span>
      </div>
      <div className="inputString">
        {!isMobile ? (
          <input
            disabled
            autoFocus={true}
            value={value}
            spellCheck={false}
            onChange={e => handleChange(e.target.value)}
          />
        ) : (
          <textarea
            disabled
            autoFocus={true}
            spellCheck={false}
            value={value}
            onChange={e => handleChange(e.target.value)}
          />
        )}
      </div>

      <div className="linkToService">
        {!!selectedService.callToActionUrl && (
          <Link to={slugToCountryPathname(selectedService.callToActionUrl || "")}>
            <span>{selectedService.callToActionText}</span>
          </Link>
        )}
      </div>

      {!isMobile ? (
        <div className="contentContainer">
          {content.ourServices?.map((service, index) => (
            <Link key={index} to={slugToCountryPathname(service.cardUrl || "")}>
              <div className="content" key={index}>
                <img className="icon" src={service.ico?.url} alt="icon" />
                <div className="container">
                  <span className="text arrow">{service.cardTitle}</span>
                  <span className="description">{service.cardSubTitle}</span>
                  <div className="tag">
                    {service.tags?.map((tag, idx) => (
                      <span key={idx}>{tag}</span>
                    ))}
                  </div>
                  <div className="price">
                    <span>{"From"}</span>
                    <div className="priceTag">{service.price}</div>
                  </div>
                </div>
                <div className={"mark"} />
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="contentContainer">
          {content.ourServices?.map((service, index) => (
            <Link key={index} to={slugToCountryPathname(service.cardUrl || "")}>
              <div className="content" key={index}>
                <div className="containerMobile">
                  <img className="icon" src={service.ico?.url} alt="icon" />
                  <div className="container">
                    <span className="text arrow">{service.cardTitle}</span>
                    <span className="description">{service.cardSubTitle}</span>
                  </div>
                </div>
                <div className="tag">
                  {service.tags?.map((tag, idx) => (
                    <span key={idx}>{tag}</span>
                  ))}
                </div>
                <div className="price">
                  <span>{"From"}</span>
                  <div className="priceTag">{service.price}</div>
                </div>
                <div className={"mark"} />
              </div>
            </Link>
          ))}
        </div>
      )}
      <div className="description">
        <span>{content.footer}</span>
      </div>
    </div>
  );
};

export default withRouter(OurServices);
